import { useEffect, useState } from "react";

// setTimeout fires at once for any delay above 2^31 - 1 ms (about 24.8 days).
const LONGEST_TIMER_MS = 2_147_483_647;

const hasPassed = (replyDeadline: string | null | undefined): boolean =>
  replyDeadline != null && Date.now() > Date.parse(replyDeadline);

export const useReplyDeadlinePassed = (replyDeadline: string | null | undefined): boolean => {
  const [passed, setPassed] = useState(() => hasPassed(replyDeadline));
  const [recheck, setRecheck] = useState(0);

  useEffect(() => {
    const nowPassed = hasPassed(replyDeadline);
    setPassed(nowPassed);
    if (replyDeadline == null || nowPassed) return undefined;
    const wait = Date.parse(replyDeadline) - Date.now() + 1;
    const timer = setTimeout(() => setRecheck((n) => n + 1), Math.min(wait, LONGEST_TIMER_MS));
    return () => clearTimeout(timer);
  }, [replyDeadline, recheck]);

  return passed;
};
